export const NAME = 'doc';